import { KycApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { AcceptanceStatus } from '@dealstack/shared/lib/generated';

export const getUiRejectionState = (status?: KycApprovalStatus) => {
	if (status === AcceptanceStatus.REJECTED || status === AcceptanceStatus.REREQUESTED) {
		return AcceptanceStatus.REREQUESTED;
	}

	return 'REJECT';
};
